import { useContext } from 'react';
import TextInput from 'components/ui-components/TextInput';
import { PostcodeSelectorContext } from '../PostcodeSelectorProvider';
import { setPostcodeAndReset } from '../postcodeSelectorStateManager';
import { validatePostcode } from '../validateFields';

const PostcodeSearchField = () => {
  const {
    id,
    dispatch,
    postcode,
    setPostcodeSearched,
    setPostcodeIsReset,
    setValue,
    errors,
    setError,
    clearErrors,
  } = useContext(PostcodeSelectorContext);

  const handleValidatePostcode = (value, inputField, validationField) => {
    validatePostcode(value, {
      inputField,
      validationField,
      setValue,
      setError,
      clearErrors,
    });

    // Reset the postcode component
    dispatch(setPostcodeAndReset(value));

    // Let the main validation know that the whole postcode component has been reset
    // And that the postcode hasn't yet been searched for
    setPostcodeIsReset(true);
    setPostcodeSearched(false);
  };

  return (
    <TextInput
      className="m-width-40"
      id={`${id}SearchPostcode`}
      label="Postcode"
      placeholder="e.g. NE1 2AB"
      value={postcode}
      onChange={event =>
        handleValidatePostcode(
          event.target.value,
          `${id}SearchPostcode`,
          `${id}SearchPostcodeValid`,
        )
      }
      errors={errors && errors[`${id}SearchPostcode`] ? errors : null}
    />
  );
};

export default PostcodeSearchField;
